export default "__VITE_ASSET__okTDEPmH__"